import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id 1D1C3847-C645-42AE-A93C-DE1E64685762
 * name vector-polyline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-polyline.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorPolylineIcon = createSvgIcon(<><path d="M2 3V9H4.95L6.95 15H6V21H12V16.41L17.41 11H22V5H16V9.57L10.59 15H9.06L7.06 9H8V3M4 5H6V7H4M18 7H20V9H18M8 17H10V19H8Z" /></>, 'VectorPolylineIcon');
export default VectorPolylineIcon